import { getVueTemplate } from "../../_imports/utils/utils.common";
import BaseFormComponent from "../_imports/base-form-component.vue";

export default {
	name: 'forms-field-error-message',
	template: getVueTemplate('forms-field-error-message'),
	mixins: [
		BaseFormComponent
	],
	props: {
		error: String
	}
};